import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { TAB_BAR_HEIGHT } from '../../../appStyles/_layout.styles';

/** Theme-aware styles so section titles and text have proper contrast in dark mode */
export const getGamesListStyles = (theme: Theme) =>
  StyleSheet.create({
    gamesList: {
      flex: 1,
      paddingHorizontal: 16,
      paddingTop: 16,
      paddingBottom: 8,
    },
    /** League mode: fill height so SectionList can scroll */
    leagueListWrapper: {
      flex: 1,
      minHeight: 0,
    },
    /** Date mode: fill height so the virtualized FlashList can scroll */
    dateListWrapper: {
      flex: 1,
      minHeight: 0,
    },
    /** Bottom padding so the last league card clears the tab bar */
    dateListContent: {
      paddingBottom: TAB_BAR_HEIGHT + 24,
    },
    loadingContainer: {
      padding: 20,
      alignItems: 'center',
    },
    loadingText: {
      fontSize: 16,
      color: theme.gray[700],
    },
    /** Centered empty state for no matches or empty section filter */
    emptyContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 32,
      paddingVertical: 48,
      minHeight: 280,
    },
    emptyIconWrap: {
      width: 88,
      height: 88,
      borderRadius: 44,
      backgroundColor: theme.primaryLight ? `${theme.primaryLight}30` : theme.primary + '25',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 20,
    },
    emptyIcon: {
      marginBottom: 0,
    },
    emptyTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: theme.gray[800],
      textAlign: 'center',
      marginBottom: 8,
    },
    emptySubtitle: {
      fontSize: 15,
      fontWeight: '400',
      color: theme.gray[600],
      textAlign: 'center',
      lineHeight: 22,
      maxWidth: 280,
    },
    sectionContainer: {
      marginBottom: 24,
    },
    sectionHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 12,
      paddingHorizontal: 4,
      flexWrap: Platform.OS === 'web' ? 'nowrap' : 'wrap',
      ...(Platform.OS === 'web' && {
        minWidth: 0,
      }),
    },
    filterButtonsContainer: {
      flexShrink: 0,
      alignItems: 'flex-end',
      marginLeft: 8,
      ...(Platform.OS === 'web' && {
        minWidth: 200,
      }),
    },
    sectionTitleChip: {
      backgroundColor: theme.gray[200],
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 20,
      alignSelf: 'flex-start',
      marginRight: 8,
    },
    sectionTitle: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.black,
      ...(Platform.OS === 'web' && {
        flexShrink: 1,
        flex: 0,
      }),
    },
    liveIndicator: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: theme.error,
      marginLeft: 4,
    },
    showMoreButton: {
      backgroundColor: theme.background.card,
      borderRadius: 8,
      paddingVertical: 12,
      paddingHorizontal: 16,
      alignItems: 'center',
      marginTop: 8,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: theme.gray[200],
      ...(Platform.OS === 'web' && {
        boxShadow: theme.shadows.card,
      }),
    },
    showMoreText: {
      fontSize: 14,
      color: theme.primary,
      fontWeight: '600',
    },
  });

